import React from "react";
import PropTypes from "prop-types";
import Message from "./Message";

function Messages(props) {
  const {message} = props;
  return (
    <React.Fragment>
      {message &&
        [`info`, `warning`, `error`, `success`].map((type) => {
          return (
            message[type] && (
              <div
                key={type}
                className={`product__message product__message-${type}`}
              >
                <Message type={type} text={message[type]} />
              </div>
            )
          );
        })}
    </React.Fragment>
  );
}

Messages.propTypes = {
  message: PropTypes.shape({
    info: PropTypes.string,
    warning: PropTypes.string,
    error: PropTypes.string
  })
};

export default Messages;
